module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<span class="message"></span>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/zbone/NoResultsItemView.tpl
// module id = 1730
// module chunks = 0